import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';

interface Item {
  MenuID: number;
  menu_name: string;
  menu_page: string;
  menu_type: string;
  menu_index: number;
}

interface currentLatestTableProps {
  items: Item[];
}

export default function CurrentLatestTable({ items }: currentLatestTableProps) {
  const [latestPage, setLatestPage] = useState(1);
  const latestPerPage = 10;
  const totalPages = Math.ceil(items.length / latestPerPage)
  const indexOfLastLatest = latestPage * latestPerPage;
  const indexOfFirstLatest = indexOfLastLatest - latestPerPage;
  const currentLatest = items.slice(indexOfFirstLatest, indexOfLastLatest);
    
  const nextLatestPage = () => {
    if (latestPage < totalPages) { 
      setLatestPage(latestPage + 1)
    }
  };
  
  const prevLatestPage = () => {
    if (latestPage > 1) {
      setLatestPage (latestPage - 1)
    }
  };
    
  return (
    <>
      <table>
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Menu name</th>
            <th style={{ width: '20%' }}>Menu page</th>
            <th style={{ width: '20%' }}>Menu type</th>
            <th style={{ width: '20%' }}>Menu index</th>
            <th style={{ width: '10%' }} className="text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {
            currentLatest.map(item => ((
              <tr key={item.MenuID}>
                <td>{item.menu_name}</td>
                <td>{item.menu_page}</td>
                <td>{item.menu_type}</td>
                <td>{item.menu_index}</td>
                <td className='text-center'>
                  <button 
                    data-tooltip-id='edit'>
                    <FontAwesomeIcon icon={faPenToSquare} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                  </button>

                  <button 
                    type='button' 
                    data-tooltip-id='delete'>
                    <FontAwesomeIcon icon={faTrash} className="text-sx text-white bg-gray-600 rounded-md p-1" />
                  </button>
                </td>
              </tr>
            )))
          }
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 space-x-4">
          <button
            onClick={() => setLatestPage(1)}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
            disabled={latestPage === 1}>
            First
          </button>

          <button
            onClick={prevLatestPage}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
            disabled={latestPage === 1}>
            Prev
          </button>

          {/* Numbered page buttons */}
          {[...Array(totalPages)].map((_, index) => {
            const pageNum = index + 1;
            const range = 1; // Show one before and after
            const show = pageNum >= latestPage - range && pageNum <= latestPage + range;

            if (show) {
              return (
                <button
                  key={pageNum}
                  onClick={() => setLatestPage(pageNum)}
                  className={`px-3 py-1 rounded ${
                    latestPage === pageNum
                      ? "bg-red-600 text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {pageNum}
                </button>
              );
            }
            return null;
          })}

          <button
            onClick={nextLatestPage}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
            disabled={latestPage === totalPages}>
            Next
          </button>

          <button
            onClick={() => setLatestPage(totalPages)}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
            disabled={latestPage === totalPages}>
            Last
          </button>
        </div>
      )}
    </>
  );
}
